/** API route map: URLS.Controller.BusinessEntity */
export const BusinessEntity = {
      Name: 'BusinessEntity/',
      GetBusinessEntities: 'get-business-entities',
      AddBusinessEntity: 'add-business-entity',
      UpdateBusinessEntity: 'update-business-entity',
      DeleteBusinessEntity: 'delete-business-entity',
};
